import { faFileEdit, faInfo, faInfoCircle, faRemove } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from '@progress/kendo-react-grid'
import { useEffect, useState } from 'react'
import { agDecisoes, agEstados, agTipoPretensoes, del, get, getAcaoSelected, getCandidaturaSelected, getDemarcacaoSelected, getDesconformidadeSelected, getDocumentoSelected, getEntidadeSelected, getIntervencaoSelected, getMobilizacaoSelected, getOcorrenciaSelected, getPatrimonioSelected, getPretensaoSelected, getProcessoSelected, GetUserNameTecnico, getUsoSoloSelected, post, preventPropsNullValues, setAcaoSelected, setCoordenadasSelected, setDemarcacaoSelected, setDesconformidadeSelected, setDocumentoSelected, setIntervencaoSelected, setMobilizacaoSelected, setOcorrenciaSelected, setPatrimonioSelected, setPretensaoSelected, setProcessoSelected, setusoSoloSelected, tipoDeProcesso, TiposUtilizacao, tipoTitulos } from '../../services/utils'
import { useDemarcacaoStore } from '../../stores/demarcacao'
import { useDhProcessoStore } from '../../stores/dhProcesso'
import { useEntidadeStore } from '../../stores/entidade'
import { useModeloStore } from '../../stores/modelo'
import { useOcorrenciaStore } from '../../stores/ocorrencias'
import { usePatrimonioStore } from '../../stores/patrimonio'

import stylesDominioHidrico from '../../styles/dominiohidrico/DominioHidrico.module.scss'
import stylesIntervencao from '../../styles/intervencao/Intervencao.module.scss'
import stylesApoioGestao from '../../styles/apoiogestao/ApoioGestao.module.scss'
import stylesEntidades from '../../styles/entidade/RegistarEntidade.module.scss'
import stylesModelos from '../../styles/modelos/RegistarModeloForm.module.scss'
import stylesUsoDoSolo from '../../styles/usodosolo/RegistarUsoDoSoloForm.module.scss'
import stylesOcorrencias from '../../styles/ocorrencia/OcorrenciasStylesv2.module.scss'
import stylesDocumentos from '../../styles/documentos/Documentos.module.scss'
import { default as styles } from '../../styles/documentos/GridDocumentos.module.scss'

import { AG_DESCONFORMIDADE, AG_PRETENSAO, AG_PRETENSOES, APOIO_GESTAO_MODULE_NAME, clearLayers, CURRENT_TIMEZONE, DELETE_ASSOCIACAO, DH_DEMARCACAO_ASSOCIACAO, DH_PATRIMONIO_ASSOCIACAO, DH_PROCESSO_ASSOCIACAO, DOCUMENTOS_MODULE_NAME, DOMINIO_HIDRICO_MODULE_NAME, ENTIDADES_MODULE_NAME, GET_AG_DESCONFORMIDADE_BY_ID, GET_DEMARCACAO, GET_OCORRENCIA, GET_PATRIMONIO, GET_PRETENSAO, GET_PROCESSO, GET_US_TITULO_BY_ID, INT_ACAO, INT_ACAO_ASSOCIACAO, INT_INTERVENCAO_ASSOCIACAO, INT_MOBILIZACAO_ASSOCIACAO, INTERVENCAO_MODULE_NAME, MODELOS_MODULE_NAME, OCORRENCIA_ASSOCIACAO, OCORRENCIAS_MODULE_NAME, PESQUISAR_ACAO, PESQUISAR_ASSOCIACAO_ACAO, PESQUISAR_ASSOCIACAO_CANDIDATURA, PESQUISAR_ASSOCIACAO_DEMARCACAO, PESQUISAR_ASSOCIACAO_DESCONFORMIDADE, PESQUISAR_ASSOCIACAO_DOCUMENTO, PESQUISAR_ASSOCIACAO_ENTIDADE, PESQUISAR_ASSOCIACAO_INTERVENCAO, PESQUISAR_ASSOCIACAO_MOBILIZACAO, PESQUISAR_ASSOCIACAO_MODELO, PESQUISAR_ASSOCIACAO_OCORRENCIA, PESQUISAR_ASSOCIACAO_PATRIMONIO, PESQUISAR_ASSOCIACAO_PRETENSAO, PESQUISAR_ASSOCIACAO_PROCESSO, PESQUISAR_ASSOCIACAO_REGISTO_VOO_DRONE, PESQUISAR_ASSOCIACAO_USOS_SOLO, PESQUISAR_INTERVENCAO, PESQUISAR_MOBILIZACAO, SAVE_NEW_ASSOCIATION, SAVE_NEW_ENTIDADE, UPDATE_ASSOCIATION, US_TITULO_ASSOCIACAO, USO_DO_SOLO_MODULE_NAME, VOO_DRONE_MODULE_NAME } from '../../utils/constants'
import EditAssociacaoForm from './EditAssociacaoForm'
import { useIntervencaoStore } from '../../stores/intervencao'
import { useAcaoStore } from '../../stores/acao'
import { useCandidaturaStore } from '../../stores/candidatura'
import { useVooDroneStore } from '../../stores/vooDrone'
import { useUsoDoSoloStore } from '../../stores/usoDoSolo'
import { Form, FormElement } from '@progress/kendo-react-form'
import { Dialog } from '@progress/kendo-react-dialogs'
import parse from 'html-react-parser';
import clsx from 'clsx'
import useClearMap from '../../hooks/useClearMap'
import { useAgDesconformidadeStore } from '../../stores/agDesconformidade'
import moment from 'moment'
import SessionStorageService from '../../services/SessionStorageService'
import { useMobilizacaoStore } from '../../stores/mobilizacao'
import { useDhPatrimonioStore } from '../../stores/dhPatrimonio'

type PageState = {
  skip: number
  take: number
}
interface EditFormProps {
  cancelEdit: () => void;
  onSubmit: (event: any) => void;
  item: any;
}


type Props = {
  pageName?: string
  viewMode: boolean
}

interface EditCommandCellProps extends GridCellProps {
  enterEdit: (item: any) => void;
  goToForm: (item: any) => void;
  deleteItem: (item: any) => void;
  pointOnMap: (item: any) => void;
}

const EditCommandCell = (props: EditCommandCellProps & { viewMode: boolean }) => {
  const { viewMode} = props;


  return (
    <td className="k-command-cell">
      <div className={'gridCommand'}>
      {viewMode &&
        <div
            role="button"
            onClick={() => props.goToForm(props.dataItem)}
            className={styles.gridCommandIconButton}
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </div>}
          {!viewMode &&
          <div
            role="button"
            onClick={() => props.deleteItem(props.dataItem)}

          >
              <FontAwesomeIcon icon={faRemove} />
            </div>
      }
      </div>
    </td>

  );
};

const initialDataState: PageState = { skip: 0, take: 10 }

export function AssociacaoListagem({ pageName, viewMode }: Props) {

  let selectedStyles;

  switch (pageName) {
    //  MODULO DOMINIO HIDRICO
    case 'processos':
      selectedStyles = stylesDominioHidrico;
      break;
    case 'patrimonio':
      selectedStyles = stylesDominioHidrico;
      break
    case 'demarcacao':
      selectedStyles = stylesDominioHidrico;
      break
    
    //  MODULO INTERVENÇÕES
    case 'intervencoes':
      selectedStyles = stylesIntervencao;
      break;
    case 'acao':
      selectedStyles = stylesIntervencao;
      break
    case 'candidatura':
      selectedStyles = stylesIntervencao;
      break
    case 'mobilizacao':
      selectedStyles = stylesIntervencao;
      break

    //  MODULO APOIO GESTÃO
    case 'pretensao':
      selectedStyles = stylesApoioGestao
      break
    case 'desconformidade':
      selectedStyles = stylesApoioGestao
      break

    case 'ocorrencias':
      selectedStyles = stylesOcorrencias;
      break;
    case 'usoDoSolo':
      selectedStyles = stylesUsoDoSolo;
      break;
    case 'entidades':
      selectedStyles = stylesEntidades;
      break;
    case 'modelos':
      selectedStyles = stylesModelos;
      break;
    case 'documentos':
      selectedStyles = stylesDocumentos;
      break;
    default:
      selectedStyles = styles;
  }

  const [instabiladeArribas, setInstabilidadeArribas] = useState(false)
  const [erosaoRecuo, setErosaoRecuo] = useState(false)
  const [protecaoDefesa, setProtecaoDefesa] = useState(false)
  const [page, setPage] = useState<PageState>(initialDataState)
  const [idToRemove, setIdToRemove] = useState(0);

  const getAssociacoesByProcesso = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_PROCESSO}/` + data);

  const getAssociacoesByEntidade = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_ENTIDADE}/` + data);

  const getAssociacoesByPretensoes = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_PRETENSAO}/` + data);

  const getAssociacoesByDesconformidades = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_DESCONFORMIDADE}/` + data);

  const getAssociacoesByOcorrencia = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_OCORRENCIA}/` + data);

  const getAssociacoesByDocumento = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_DOCUMENTO}/` + data);

  const getAssociacoesByUsosSolo = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_USOS_SOLO}/` + data);

  const selectedProcessoResult: any = useDhProcessoStore((state) => state.selectedDhProcessoResult);
  const selectProcessoResult = useDhProcessoStore((state) => state.selectDhProcessoResult)
  const selectProcessoResultId = useDhProcessoStore((state) => state.selectDhProcessoResultId)

  const getAssociacoesByPatrimonio = async (data: any) =>
    await get<any, any>(`${PESQUISAR_ASSOCIACAO_PATRIMONIO}/` + data);

  const getAssociacoesByIntervencao = async (data: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_INTERVENCAO}/` + data);

  const getAssociacoesByAcao = async (data: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_ACAO}/` + data);

  const getAssociacoesByCandidatura = async (data: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_CANDIDATURA}/` + data);

  const getAssociacoesByMobilizacao = async (data: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_MOBILIZACAO}/` + data);

  const getAssociacoesByDemarcacao = async (data: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_DEMARCACAO}/` + data);  
  
  const getAssociacoesByRegistoVooDrone = async (id: any) =>
  await get<any, any>(`${PESQUISAR_ASSOCIACAO_REGISTO_VOO_DRONE}/${id}`);

  const deleteAssociacao = async(id: any) => await del<any, any>(`${DELETE_ASSOCIACAO}/${id}`, {})

  const selectedEntidadeResult: any = useEntidadeStore(state => state.selectedEntidadeResult);
  const selectOcorrenciaResult = useOcorrenciaStore(
    (state) => state.selectOcorrenciaResult
  );
  const selectEntidadeResult = useEntidadeStore(
    (state) => state.selectEntidadeResult
  );

  const selectPatrimonioResult = usePatrimonioStore(
    (state) => state.selectPatrimonioResult
  );

  const selectDemarcacaoResult = useDemarcacaoStore(
    (state) => state.selectDemarcacaoResult
  );

  const selectDemarcacaoResultId = useDemarcacaoStore(
    (state) => state.selectDemarcacaoResultId
  );

    const selectModeloResult = useModeloStore(
    (state) => state.selectModeloResult
  );

   const selectIntervencaoResult = useIntervencaoStore(
    (state) => state.selectIntervencaoResult
  );

   const selectAcaoResult = useAcaoStore(
    (state) => state.selectAcaoResult
  );
  const selectCandidaturaResult = useCandidaturaStore(
    (state) => state.selectCandidaturaResult
  );
  const selectedOcorrenciaResult: any = useOcorrenciaStore(state => state.selectedOcorrenciaResult);

  const selectedModeloResult: any = useModeloStore(
    (state) => state.selectedModeloResult
  )
  const selectedModeloResultId = useModeloStore(
    (state) => state.selectedModeloResultId
  )

  const selectedVooDronePathResult: any = useVooDroneStore(
    (state) => state.selectedVooDronePathResult
  )

  const selectedUsoDoSoloResult: any = useUsoDoSoloStore(
    (state) => state.selectedUsoDoSoloResult
  )
  
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()
  const [entidades, setEntidades] = useState([]);
  const createAssociation = async (data: any) => await post<any, any>(`${SAVE_NEW_ASSOCIATION}`, data);
  const updateAssociation = async (data: any) => await post<any, any>(`${UPDATE_ASSOCIATION}`, data);
  const createEntidade = async (data: any) =>
    await post<any, any>(`${SAVE_NEW_ENTIDADE}`, data)
  const [openModalDescartar, setOpenModalDescartar] = useState<any>()

  useEffect(() => {
    initForm();

  }, []);

  const initForm = () => {
    const modulo = sessionStorage.getItem("Modulo");

    switch (modulo) {
      case DOMINIO_HIDRICO_MODULE_NAME: {

        const patrimonioSelected = getPatrimonioSelected();
        const demarcacaoSelected = getDemarcacaoSelected();
        const processoSelected = getProcessoSelected();

        if (patrimonioSelected && patrimonioSelected?.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByPatrimonio(patrimonioSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        } else if (demarcacaoSelected && demarcacaoSelected?.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByDemarcacao(demarcacaoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        } else if (processoSelected && processoSelected?.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByProcesso(processoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        } else {
          setData([]);
        }

        break;

      }
      case INTERVENCAO_MODULE_NAME: {

       
        const intervencaoSelected = getIntervencaoSelected();
        const acaoSelected = getAcaoSelected();
        const candidaturaSelected = getCandidaturaSelected();
        const mobilizacaoSelected = getMobilizacaoSelected();

        if (intervencaoSelected && intervencaoSelected?.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByIntervencao(intervencaoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        } else if(acaoSelected && acaoSelected.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByAcao(acaoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        }else if(candidaturaSelected && candidaturaSelected.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByCandidatura(candidaturaSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })        
        }else if(mobilizacaoSelected && mobilizacaoSelected.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByMobilizacao(mobilizacaoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        
        }
        break;
      }
      case ENTIDADES_MODULE_NAME: {

        const entidadeSelected = getEntidadeSelected();
        if (entidadeSelected) {
          postMessage({ type: 'showLoader' }, '*')
          getAssociacoesByEntidade(entidadeSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*')
          });
        } else {
          setData([]);
        }

        break;

      }
      case OCORRENCIAS_MODULE_NAME: {

        if (selectedOcorrenciaResult) {
          postMessage({ type: 'showLoader' }, '*')
          getAssociacoesByOcorrencia(selectedOcorrenciaResult?.id ?? getOcorrenciaSelected().id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*')
          })
        }

        break;

      }
      case USO_DO_SOLO_MODULE_NAME: {
          
          if (getUsoSoloSelected()?.id) {
            postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByUsosSolo(selectedUsoDoSoloResult?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*')
          })
      }

        break;

      }
      case DOCUMENTOS_MODULE_NAME: {
        if (getDocumentoSelected()?.id) {
          postMessage({ type: 'showLoader' }, '*');
          const documentoSelected = getDocumentoSelected();
          getAssociacoesByDocumento(documentoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*')
          })
        }
        break;
      }
      case APOIO_GESTAO_MODULE_NAME: {

        const pretensaoSelected = getPretensaoSelected();
        const desconformidadeSelected = getDesconformidadeSelected();
        if (pretensaoSelected && pretensaoSelected.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByPretensoes(pretensaoSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        } else if (desconformidadeSelected && desconformidadeSelected.id) {
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByDesconformidades(desconformidadeSelected?.id).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })
        }

        break;
      }

      case VOO_DRONE_MODULE_NAME:{
        if(selectedVooDronePathResult && selectedVooDronePathResult?.id_registo_voo_drone){
          const id_registo_voo_drone = selectedVooDronePathResult?.id_registo_voo_drone;
          postMessage({ type: 'showLoader' }, '*');
          getAssociacoesByRegistoVooDrone(id_registo_voo_drone).then(result => {
            setData(result);
            postMessage({ type: 'hideLoader' }, '*');
          })

        }
        break;
      }
    }
  }

  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }
  const [data, setData] = useState<any>();

  const [openForm, setOpenForm] = useState<boolean>(false);
  const [editItem, setEditItem] = useState<any>({ id: undefined });
  const [clearMap] = useClearMap();
  const getDesconformidade = async (data: any) =>
    await get<any, any>(`${GET_AG_DESCONFORMIDADE_BY_ID}/` + data)

  const selectOcorrenciaResultId = useOcorrenciaStore(
    (state) => state.selectOcorrenciaResultId
  )
  const selectAgDesconformidadeResultId = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResultId
  )
  const selectAgDesconformidadeResult = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResult
  )
  const getPretensao = async (data: any) =>
    await get<any>(`${GET_PRETENSAO}/` + data)

  const getAcaoById = async (id: any) =>
    await get<any, any>(`${PESQUISAR_ACAO}/` + id)

  const getMobilizacao = async (data: any) =>
    await get<any, any>(`${PESQUISAR_MOBILIZACAO}/` + data)

  const getIntervencaoById = async (id: any) =>
    await get<any, any>(`${PESQUISAR_INTERVENCAO}/` + id)

  const getProcesso = async (data: any) => await get<any, any>(`${GET_PROCESSO}/` + data)
  const getDemarcacao = async (data: any) => await get<any, any>(`${GET_DEMARCACAO}/` + data)
  const getPatrimonio = async (data: any) => await get<any, any>(`${GET_PATRIMONIO}/` + data)
  const getOcorrencia = async (data: any) =>
    await get<any, any>(`${GET_OCORRENCIA}/` + data)

  const getUsoDoSolo = async (data: any) =>
    await get<any, any>(`${GET_US_TITULO_BY_ID}/` + data)

  const selectUsoDoSoloResultId = useUsoDoSoloStore(
    (state) => state.selectUsoDoSoloResultId
  )
  const selectUsoDoSoloResult = useUsoDoSoloStore(
    (state) => state.selectUsoDoSoloResult
  )
  const selectMobilizacaoResult = useMobilizacaoStore(
    (state) => state.selectMobilizacaoResult
  )
  const selectMobilizacaoResultId = useMobilizacaoStore(
    (state) => state.selectMobilizacaoResultId
  )

  const selectPatrimonioResultId = useDhPatrimonioStore((state) => state.selectDhPatrimonioResultId)

  const enterEdit = (item: any) => {
    setOpenForm(true);
    setEditItem(item);
  };
  const pointOnMap = (item: any) => {
    console.log(item);
    return;
  };
  const deleteItem = (item: any) => {
    setIdToRemove(item.id);
    setOpenModalDescartar(true);
    initForm();
  };

  const goToForm = async (item: any) => {
    const match = item.resumo.match(/id:\s*(\d+)/);
    let idValue;
    if (match) {
        idValue = match[1];
        console.log(idValue);  // Output: 306
    } else {
      postMessage({type : "infoMsg", value: {message: "Id não encontrado."}});
      return;
    }
    const iframe: any = document.getElementById('iframeGeoPortal')
    console.log(idValue);
    if (sessionStorage.getItem("Modulo") == OCORRENCIAS_MODULE_NAME) {
      clearMap(clearLayers["CLEAR_LAYERS_OCORRENCIAS"]);
      setOcorrenciaSelected(undefined)
      setCoordenadasSelected(undefined)
      selectOcorrenciaResult(undefined)
      selectOcorrenciaResultId(undefined)
    }
    if (item.tipo == OCORRENCIAS_MODULE_NAME) {
      console.log(item.tipo);
    }
    else if (item.tipo == AG_PRETENSAO) {
      const pretensao = await getPretensao(idValue);
      const tecnico = await GetUserNameTecnico(pretensao.utilizador_id);
       
      const objToShow = {
        ...pretensao,
        decisao: agDecisoes.filter((x: any) => x.id == pretensao.ag_decisao_id)[0],
        id: pretensao.id,
        file_doc_numero: pretensao.file_doc_numero,
        numeroProcesso: pretensao.numero_do_processo,
        nifRequerente: pretensao.requerente_nif,
        nomeRequerente: pretensao.requerente_nome,
        dataHoraRegisto: new Date(pretensao.data_registo),
        assunto: pretensao.assunto,
        estado: agEstados.filter((x: any) => x.id == pretensao.ag_estado_id)[0],
        tipoPretensao: agTipoPretensoes.filter((x: any) => x.id == pretensao.ag_tipo_pretensao_id)[0],
        dataEntrada: new Date(pretensao.data_entrada),
        data_decisao: new Date(pretensao.data_decisao),
        local: pretensao.local,
        obs: pretensao.observacoes,
        geom_imported: pretensao.geom_imported,
        tecnicoRegisto: tecnico
      }
      
      iframe.contentWindow?.postMessage(
        { type: 'SiarlRemoveSelection', value: "true" },
        '*'
      )
      iframe.contentWindow?.postMessage(
        { type: 'SiarlPretensaoSearch', value: [pretensao?.id] },
        '*'
      )
      setPretensaoSelected(objToShow);
      sessionStorage.setItem("Modulo", APOIO_GESTAO_MODULE_NAME);
      postMessage({type: "form", value: "registarApoioGestaoPretensao"});
    }
    else if (item.tipo == AG_DESCONFORMIDADE) {
      
      const desconformidade = await getDesconformidade(idValue);
      const tecnico = await GetUserNameTecnico(desconformidade.utilizador_id);
    
      if (!desconformidade) {
        postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
        return;
      }
    
      const dataToSend : any ={
        ...desconformidade,
        tecnicoRegisto : tecnico
    
      }
    
      const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage(
        { type: 'SiarlRemoveSelection', value: "true" },
        '*'
      )
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDesconformidadeSearch', value: [desconformidade?.id] },
        '*'
      )
      selectAgDesconformidadeResult(dataToSend)
      selectAgDesconformidadeResultId(desconformidade?.id)
      setDesconformidadeSelected(desconformidade);
      sessionStorage.setItem("Modulo", APOIO_GESTAO_MODULE_NAME);
      postMessage({type: "form", value: "registarApoioGestaoDesconformidade"});
    } else if (item.tipo == INT_INTERVENCAO_ASSOCIACAO) {
      
      const intervencao = await getIntervencaoById(idValue);
      const tecnico = await GetUserNameTecnico(intervencao.utilizador_id);

    const objToShow = {
        ...intervencao,
        utilizador_nome: tecnico,
        id: intervencao.id,
        localizacao: intervencao?.localizacao ?? undefined,
        nuts1: intervencao.nuts1 ?? undefined,
        nuts2: intervencao.nuts2 ?? undefined,
        nuts3: intervencao.nuts3 ?? undefined,
        distrito : intervencao.distrito ?? undefined,
        concelho: intervencao.mobilizacao ?? undefined,
        freguesia: intervencao.freguesia ?? undefined,
        arh: intervencao.arh ?? undefined,
        capitania : intervencao.capitania ?? undefined,
        massaagua: intervencao.massaagua ?? undefined,
        inicio : intervencao.inicio? new Date(intervencao?.inicio) : undefined,
        fim : intervencao.fim? new Date(intervencao?.fim) : undefined,
        id_tipo_n1: intervencao?.tipo_n1 ?? undefined,
        id_tipo_n2: intervencao?.tipo_n2 ?? undefined,
        id_tipo_n3: intervencao?.tipo_n3 ?? undefined,
        id_prioridade: intervencao?.int_prioridade ?? undefined,
        id_int_pal_xxi_tip_nivel_1: intervencao?.int_pal_xxi_tip_nivel_1 ?? undefined,
        id_int_pal_xxi_tip_nivel_2: intervencao?.int_pal_xxi_tip_nivel_2 ?? undefined,
        id_int_pal_xxi_tip_nivel_3: intervencao?.int_pal_xxi_tip_nivel_3 ?? undefined,
        id_int_instrumento_planeamento: intervencao?.int_instrumento_planeamento ?? undefined,
        entidade: intervencao?.entidade,
        designacao: intervencao?.designacao ?? undefined,
        lstEntidades: preventPropsNullValues(intervencao.lstEntidades, "nome") ?? undefined,
        lstFinanciamento: preventPropsNullValues(intervencao.lstFinanciamento, "designacao") ?? undefined,
        fin_comunitario: intervencao?.fin_comunitario ?? undefined,
        fin_nacional: intervencao?.fin_nacional ?? undefined

      }

      selectIntervencaoResult(objToShow);
      setIntervencaoSelected(objToShow);
      const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlRemoveSelection',
          value: 'true',
        },
        '*'
      )
      iframe.contentWindow?.postMessage({ type: "SiarlIntIntervencaoSearch", value: [intervencao?.id] }, '*')
      sessionStorage.setItem("Modulo", INTERVENCAO_MODULE_NAME);
      postMessage({type: "form", value: "registarIntervencao"}, "*");
    
    } else if (item.tipo == INT_ACAO_ASSOCIACAO) {
      const acao = await getAcaoById(idValue);
      const tecnico = await GetUserNameTecnico(acao.utilizador_id);

      const objToShow = {
        ...acao,
        id: acao.id,
        n_processo_aquisitivo: acao.n_processo_aquisitivo ?? undefined,
        n_filedoc: acao.n_filedoc ?? undefined,
        designacao: acao.designacao ?? undefined,
        id_estado: acao.id_estado ?? undefined,
        nuts1: acao.nuts1 ?? undefined,
        nuts2: acao.nuts2 ?? undefined,
        nuts3: acao.nuts3 ?? undefined,
        distrito : acao.distrito ?? undefined,
        concelho: acao.mobilizacao ?? undefined,
        freguesia: acao.freguesia ?? undefined,
        arh: acao.arh ?? undefined,
        capitania : acao.capitania ?? undefined,
        massaagua: acao.massaagua ?? undefined,
  
  
        data_ini_p : acao.data_ini_p?new Date(acao?.data_ini_p):null,
        data_con_p : acao.data_con_p?new Date(acao?.data_con_p):null,
        data_ini_e : acao.data_ini_e?new Date(acao?.data_ini_e):null,
        data_con_e : acao.data_con_e?new Date(acao?.data_con_e):null,
        id_tipo_n1: acao?.tipo_n1 ?? undefined,
        id_tipo_n2: acao?.tipo_n2 ?? undefined,
        id_tipo_n3: acao?.tipo_n3 ?? undefined,
        id_tipo_n4: acao?.tipo_n4 ?? undefined,
  
  
        entidade : acao.diEntidade ?? undefined,
        tipo_engenharia : acao.tipo_engenharia ?? undefined,
        id_natureza_acao : acao.id_natureza_acao ?? undefined,
        id_int_acao_componente : acao.int_acao_componente ?? undefined,
        id_int_acao_planeamento: acao.int_acao_planeamento ?? undefined,
        comunitario : acao.comunitario ?? undefined,
        nacional : acao.nacional ?? undefined,
        numero_candidatura : acao.numero_candidatura ?? undefined,
        designacao_candidatura : acao.designacao_candidatura ?? undefined,
        inv_previs : acao.inv_previs ?? undefined,
        val_contrat : acao.val_contrat ?? undefined,
        inv_realizado : acao.inv_realizado ?? undefined,
        revisao_precos : acao.revisao_precos ?? undefined,
        local: acao.local ?? undefined,
        utilizador_id: tecnico,
        taxa_execucao : acao.taxa_execucao ?? undefined,
        valor_por_executar : acao.valor_por_executar ?? undefined,
        data_adjudicacao : acao.data_adjudicacao?new Date(acao?.data_adjudicacao):null,
        data_artigo : acao.data_artigo?new Date(acao?.data_artigo):null,
        data_tutela : acao.data_tutela?new Date(acao?.data_tutela):null,
        data_tc : acao.data_tc?new Date(acao?.data_tc):null,
        obs: acao.obs ?? undefined,
        data_registo: acao.data_registo?new Date(acao?.data_registo):null,
  
  
      }

      selectAcaoResult(objToShow);
      setAcaoSelected(objToShow);
      sessionStorage.setItem('novaAcao', 'false')
      const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: 'true' }, '*')
      iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoSearch", value: [acao?.id] }, '*')
      sessionStorage.setItem("Modulo", INTERVENCAO_MODULE_NAME);
      postMessage({type: "form", value : "registarAcao"}, "*");
    }
    else if (item.tipo == INT_MOBILIZACAO_ASSOCIACAO) {
      const iframe: any = document.getElementById('iframeGeoPortal')
    const mobilizacao = await getMobilizacao(idValue);
    const tecnico = await GetUserNameTecnico(mobilizacao.utilizador_id);

    
    if (!mobilizacao) {
      postMessage({type: "infoMsg", value: {message: "Registo desativado."}}, "*");
      return;
    }
    const objToShow = {
      ...mobilizacao,
      id: mobilizacao.id ?? undefined,
      descricao: mobilizacao.descricao ?? undefined,
      nuts1: mobilizacao.nuts1 ?? undefined,
      nuts2: mobilizacao.nuts2 ?? undefined,
      nuts3: mobilizacao.nuts3 ?? undefined,
      distrito : mobilizacao.distrito ?? undefined,
      concelho: mobilizacao.mobilizacao ?? undefined,
      entidade_responsavel: mobilizacao.entidade ?? undefined,
      freguesia: mobilizacao.freguesia ?? undefined,
      arh: mobilizacao.arh ?? undefined,
      capitania : mobilizacao.capitania ?? undefined,
      massaagua: mobilizacao.massaagua ?? undefined,
      praia: mobilizacao.praia ?? undefined,
      data_mobilizacao: mobilizacao?.data? new Date(mobilizacao?.data):null,
      data_registo: mobilizacao?.data_registo? new Date(mobilizacao?.data_registo):null,
      data_inicio: mobilizacao?.data_inicio ? new Date(mobilizacao.data_inicio) : undefined,
      data_fim: mobilizacao.data_fim ? new Date(mobilizacao.data_fim) : undefined,
      id_int_mobilizacao_funcao: mobilizacao.int_mobilizacao_funcao ?? undefined,
      tipo_mo : mobilizacao.tipo_mo ?? undefined,
      volume: mobilizacao.volume ?? undefined,
      tipo_mancha_nivel_1_id: mobilizacao.intMobMancEmprestimoNivel1 ?? undefined,
      tipo_mancha_nivel_2_id: mobilizacao.intMobMancEmprestimoNivel2 ?? undefined,
      tipo_metodo_dragagem_id : mobilizacao.mobMetodoDragagem ?? undefined,
      tipo_local_deposicao_1_id : mobilizacao.intMobDescritivoLocalDeposicaoNivel1 ?? undefined,
      tipo_local_deposicao_2_id : mobilizacao.intMobDescritivoLocalDeposicaoNivel2 ?? undefined,
      tipo_mob_metodo_deposicao : mobilizacao.mobMetodoDeposicao ?? undefined,
      tipo_mob_objetivo_dep_1_id: mobilizacao.intMobObjetivoDeposicaoNivel1 ?? undefined,
      tipo_mob_objetivo_dep_2_id: mobilizacao.intMobObjetivoDeposicaoNivel2 ?? undefined,
      td_mob_qualidade: mobilizacao.mobQualidade ?? undefined,
      td_mob_granulometria : mobilizacao.mobGranulometria ?? undefined,
      int_mobilizacao_estado: mobilizacao.int_mobilizacao_estado ?? undefined,
      id_entidade: mobilizacao.entidade ?? undefined,
      utilizador_id: tecnico,
      observacoes: mobilizacao.observacoes ?? undefined,
      local: mobilizacao.ref_localizacao ?? undefined

    }
    sessionStorage.setItem('novaMobilizacao', 'false')
    SessionStorageService.setItem('mobilizacaoAntiga', "true")
    SessionStorageService.setItem('mobilizacaoSubmetida', "false")


    selectMobilizacaoResult(objToShow)
    selectMobilizacaoResultId(mobilizacao?.id)
    setMobilizacaoSelected(objToShow);

    sessionStorage.setItem("Modulo", INTERVENCAO_MODULE_NAME);
    postMessage({type: "form", value: "registarMobilizacao"}, "*");
    const idToSend = [mobilizacao?.id];

    iframe.contentWindow?.postMessage({ type: "SiarlIntMobilizacaoSearch", value: idToSend }, '*')

    iframe.contentWindow?.postMessage({ type: "SiarlIntMobilizacaoCenter", value: idToSend }, '*')
    } else if (item.tipo == DH_PROCESSO_ASSOCIACAO) {
        const processo = await getProcesso(idValue);

        const tecnico = await GetUserNameTecnico(processo.tecnico_id);
        
        if (!processo) {
        postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
        return;
        }

        const seletedProcessoReulst = {
            ...processo,
            tecnico_id : tecnico,
            id_tipo_processo: processo.dhTipoProcesso ?? undefined,
            id_localizacao_processo: processo.dhLocalizacaoProcesso ?? undefined,
            id_fase_pr: processo.dhFaseProcedimentoDelimitacao ?? undefined,
            id_tipo_va: processo.dhValidacaoProva ?? undefined,
            id_tipo_pa: processo.dhTipoParcela ?? undefined,
            id_tipo_se: processo.dhTipoSentenca ?? undefined,
            id_tipo_ac: processo.dhTipoDecisaoFinal ?? undefined,
            id_tipo_es: processo.dhEstadoProcesso ?? undefined,
            id_tipo_pe: processo.dhTipoPendencia ?? undefined,
            id_tipo_no: processo.dhTipoNotificacao ?? undefined,
            id_situ_no: processo.dhTipoSituacaoNotificacao ?? undefined,
            id_cond_pr: processo.dhCondicionantesProcesso ?? undefined,
            id_tipo_aj: processo.dhTipoAcaoJudicial ?? undefined,
            id_tipo_de: processo.dhTipoDesafetacao ?? undefined,
            id_tipo_aq: processo.dhTipoAquisicao ?? undefined,
            id_tipo_in: processo.dhTipoIniciativa ?? undefined,
            n_cdpm : processo.np_cdpm ?? undefined,
            data_requer: processo.data_requer ? moment.utc(processo.data_requer).tz(CURRENT_TIMEZONE) : undefined ,
            data_registo: processo.data_registo ? moment.utc(processo.data_registo).tz(CURRENT_TIMEZONE) : undefined,

            tipo_geom_indefinida: processo.tipo_geom_indefinida ?? undefined,
            np_ent_por: processo.np_ent_por ?? undefined,
            np_apa_rpp: processo.np_apa_rpp ?? undefined,
            requerente: processo.requerente ?? undefined,
            representante: processo.representante ?? undefined,
            assunto: processo.assunto ?? undefined,
            np_mp: processo.np_mp ?? undefined,
            np_comum: processo.np_comum ?? undefined,
            lugar: processo.lugar ?? undefined,
            rpp_antes_DL: processo.DhReconhecimentoPropriedadePrivada ?? undefined,
            rpp_depois_DL: processo.DhTipoAcaoReconhecimento ?? undefined
        }

        sessionStorage.setItem('novoProcesso', 'false')
        selectProcessoResultId(processo.id as number)
        selectProcessoResult(seletedProcessoReulst)
        setProcessoSelected(seletedProcessoReulst);
        const iframe: any = document.getElementById('iframeGeoPortal')

        iframe.contentWindow?.postMessage(
            { type: 'SiarlProcessoSearch', value: [idValue] },
            '*'
        )
        iframe.contentWindow?.postMessage(
            { type: 'SiarlProcessoCenter', value: [idValue] },
            '*'
        )
        sessionStorage.setItem("Modulo", DOMINIO_HIDRICO_MODULE_NAME);

        postMessage({type: "form", value: "registarProcesso"}, "*")

        if (!!processo.dhAutos && processo.dhAutos.length > 0) {
            const ids = processo.dhAutos.map((x: any) => x.id);
            const iframe: any = document.getElementById('iframeGeoPortal')
            iframe.contentWindow?.postMessage({ type: "SiarlDhAutosSearch", value: ids }, '*')
        }
        if (!!processo.dhAutosVertices && processo.dhAutosVertices.length > 0) {
            const ids = processo.dhAutosVertices.map((x: any) => x.id);
            const iframe: any = document.getElementById('iframeGeoPortal')
            iframe.contentWindow?.postMessage({ type: "SiarlDhAutosVerticesSearch", value: ids }, '*')
        }
    } else if (item.tipo == DH_DEMARCACAO_ASSOCIACAO) {
        const demarcacao = await getDemarcacao(idValue);
        const tecnico = await GetUserNameTecnico(demarcacao.tecnico_id);

        if (!demarcacao) {
            postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
            return;
          }

        const seletedDemarcacaoReulst = {
            ...demarcacao,
            tecnicoRegisto : tecnico,
            id_tipo_demarcacao: demarcacao.dhTipoDemarcacao ?? undefined,
            id_localizacao_demarcacao: demarcacao.dhLocalizacaoDemarcacao ?? undefined,
            id_fase_pr: demarcacao.dhFaseProcedimentoDelimitacao ?? undefined,
            id_tipo_va: demarcacao.dhValidacaoProva ?? undefined,
            id_tipo_pa: demarcacao.dhTipoParcela ?? undefined,
            id_tipo_se: demarcacao.dhTipoSentenca ?? undefined,
            id_tipo_ac: demarcacao.dhTipoDecisaoFinal ?? undefined,
            id_tipo_es: demarcacao.dhEstadoDemarcacao ?? undefined,
            id_tipo_pe: demarcacao.dhTipoPendencia ?? undefined,
            id_tipo_no: demarcacao.dhTipoNotificacao ?? undefined,
            id_situ_no: demarcacao.dhTipoSituacaoNotificacao ?? undefined,
            id_cond_pr: demarcacao.dhCondicionantesDemarcacao ?? undefined,
            id_tipo_aj: demarcacao.dhTipoAcaoJudicial ?? undefined,
            id_tipo_de: demarcacao.dhTipoDesafetacao ?? undefined,
            id_tipo_aq: demarcacao.dhTipoAquisicao ?? undefined,
            id_tipo_in: demarcacao.dhTipoIniciativa ?? undefined,
            data_registo: demarcacao.data_registo ? moment.utc(demarcacao.data_registo).tz(CURRENT_TIMEZONE) : undefined,

            filedoc_cod: demarcacao.filedoc_cod ?? undefined,
            designacao: demarcacao.designacao ?? undefined
          }
        sessionStorage.setItem('novaDemarcacao', 'false')
        selectDemarcacaoResultId(demarcacao.id as number)
        selectDemarcacaoResult(seletedDemarcacaoReulst)
        setDemarcacaoSelected(seletedDemarcacaoReulst);

        const iframe: any = document.getElementById('iframeGeoPortal')

        iframe.contentWindow?.postMessage(
          { type: 'SiarlDemarcacaoSearch', value: [demarcacao.id] },
          '*'
          )
        iframe.contentWindow?.postMessage(
        { type: 'SiarlDemarcacaoCenter', value: [demarcacao.id] },
        '*'
        )
        sessionStorage.setItem("Modulo", DOMINIO_HIDRICO_MODULE_NAME);
        postMessage({type: "form", value :"registarDemarcacao"}, "*")
    }

    else if (item.tipo == DH_PATRIMONIO_ASSOCIACAO) {
      const patrimonio = await getPatrimonio(idValue);

        const tecnico = await GetUserNameTecnico(patrimonio.tecnico_id);

        if (!patrimonio) {
          postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
          return;
        }

        const seletedPatrimonioReulst = {
            ...patrimonio,
            tecnicoRegisto: tecnico,
            id_tipo_patrimonio: patrimonio.dhTipoPatrimonio ?? undefined,
            id_localizacao_patrimonio: patrimonio.dhLocalizacaoPatrimonio ?? undefined,
            id_fase_pr: patrimonio.dhFaseProcedimentoDelimitacao ?? undefined,
            id_tipo_va: patrimonio.dhValidacaoProva ?? undefined,
            id_tipo_pa: patrimonio.dhTipoParcela ?? undefined,
            id_tipo_se: patrimonio.dhTipoSentenca ?? undefined,
            id_tipo_ac: patrimonio.dhTipoDecisaoFinal ?? undefined,
            id_tipo_es: patrimonio.dhEstadoPatrimonio ?? undefined,
            id_tipo_pe: patrimonio.dhTipoPendencia ?? undefined,
            id_tipo_no: patrimonio.dhTipoNotificacao ?? undefined,
            id_situ_no: patrimonio.dhTipoSituacaoNotificacao ?? undefined,
            id_cond_pr: patrimonio.dhCondicionantesPatrimonio ?? undefined,
            id_tipo_aj: patrimonio.dhTipoAcaoJudicial ?? undefined,
            id_tipo_de: patrimonio.dhTipoDesafetacao ?? undefined,
            id_tipo_aq: patrimonio.dhTipoAquisicao ?? undefined,
            id_tipo_in: patrimonio.dhTipoIniciativa ?? undefined,
            data_registo: patrimonio.data_registo ? moment.utc(patrimonio.data_registo).tz(CURRENT_TIMEZONE) : undefined,
            filedoc_cod: patrimonio.filedoc_cod ?? undefined,
            diploma: patrimonio.diploma ?? undefined,
            designacao: patrimonio.designacao ?? undefined,
            lugar: patrimonio.lugar ?? undefined,
        }

        sessionStorage.setItem('novoPatrimonio', 'false')
        selectPatrimonioResultId(patrimonio.id as number)
        selectPatrimonioResult(seletedPatrimonioReulst)
        setPatrimonioSelected(seletedPatrimonioReulst);
        postMessage({type: "form", value: "registarPatrimonio"}, "*")

        const iframe: any = document.getElementById('iframeGeoPortal')

        iframe.contentWindow?.postMessage(
          { type: 'SiarlPatrimonioSearch', value: [idValue] },
          '*'
          )
        iframe.contentWindow?.postMessage(
        { type: 'SiarlPatrimonioCenter', value: [idValue] },
        '*'
        )
    }
    else if (item.tipo == US_TITULO_ASSOCIACAO) {

      const tituloUsoDoSolo = await getUsoDoSolo(idValue);

      if (!tituloUsoDoSolo) {
        postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
        return;
      }
      const tecnico = await GetUserNameTecnico(tituloUsoDoSolo.utilizador_id);
      
      selectUsoDoSoloResultId(tituloUsoDoSolo.id)
      const usosSoloObject = {
        ...tituloUsoDoSolo,
        titulo: tituloUsoDoSolo?.titulo ?? undefined,
        id: tituloUsoDoSolo?.id ?? undefined,
        idProcesso: tituloUsoDoSolo?.id_processo ?? undefined,
        data_entrada_vigor: tituloUsoDoSolo.data_entrada_vigor ? moment.utc(tituloUsoDoSolo.data_entrada_vigor).tz(CURRENT_TIMEZONE) : undefined,
        data_expiracao: tituloUsoDoSolo.data_expiracao ? moment.utc(tituloUsoDoSolo.data_expiracao).tz(CURRENT_TIMEZONE) : undefined,
        data_alteracao_licenciamento: tituloUsoDoSolo.data_alteracao_licenciamento ? moment.utc(tituloUsoDoSolo.data_alteracao_licenciamento).tz(CURRENT_TIMEZONE) : undefined,
        data_emissao: tituloUsoDoSolo.data_emissao ? moment.utc(tituloUsoDoSolo.data_emissao).tz(CURRENT_TIMEZONE) : undefined,
        designacao: tituloUsoDoSolo?.designacao ?? undefined,
        freguesia: tituloUsoDoSolo?.freguesia ?? undefined,
        massaagua : tituloUsoDoSolo?.massaagua ?? undefined,
        praia: tituloUsoDoSolo?.praia ?? undefined,
        tecnicoRegisto: tecnico,
        data_registo: tituloUsoDoSolo.data_registo ? moment.utc(tituloUsoDoSolo.data_registo).tz(CURRENT_TIMEZONE) : undefined,
        designacaoIdentificacao: tituloUsoDoSolo?.designacao ?? undefined,
        tipoDeProcesso: tituloUsoDoSolo?.tipo_processo_id && tipoDeProcesso ? tipoDeProcesso.find(x => x.id == tituloUsoDoSolo?.tipo_processo_id) : undefined,
        codProcesso: tituloUsoDoSolo?.codigo_processo ?? undefined,
        tipoUtilizacao: tituloUsoDoSolo?.tipo_utilizacao_id ? TiposUtilizacao.find(x => x.id == tituloUsoDoSolo?.tipo_utilizacao_id) : undefined,
        codUtilizacao: tituloUsoDoSolo?.codigo_utilizacao ?? undefined,
        categoria: tituloUsoDoSolo?.categoria ?? undefined,
        nifRequerente: tituloUsoDoSolo?.nif_requerente ?? undefined,
        nomeRequerente: tituloUsoDoSolo?.nome_requerente ?? undefined,
        obs: tituloUsoDoSolo?.observacoes ?? undefined,
        filedoc_cod: tituloUsoDoSolo?.filedoc_cod ?? undefined,
        estado_id: tituloUsoDoSolo?.estado ?? undefined,
        tipo_registo: tituloUsoDoSolo?.tipo_registo ?? undefined,
        urlTitulo: tituloUsoDoSolo?.url_titulo ?? undefined,
        tipoTitulo: tituloUsoDoSolo?.tipo_titulo_id ? tipoTitulos.find (x => x.id == tituloUsoDoSolo?.tipo_titulo_id) : undefined,
        urlProcesso: tituloUsoDoSolo?.url_processo ?? undefined

      }
      sessionStorage.setItem('usGeomEdited', 'false')

      selectUsoDoSoloResult(usosSoloObject);
      setusoSoloSelected(usosSoloObject);
      SessionStorageService.setItem("novoUsTitulo", 'false');
      sessionStorage.setItem("Modulo", USO_DO_SOLO_MODULE_NAME);
      
      postMessage({type: "form", value: "registarUsoDoSolo"}, "*")
      const iframe: any = document.getElementById('iframeGeoPortal')

      iframe.contentWindow?.postMessage({ type: "SiarlUsTituloSearch", value: [tituloUsoDoSolo?.id] }, '*')

      iframe.contentWindow?.postMessage({ type: "SiarlUsTituloCenter", value: [tituloUsoDoSolo?.id] }, '*')
    } else if (item.tipo == OCORRENCIA_ASSOCIACAO) {
      const ocorrencia = await getOcorrencia(idValue);

      const entidadeByUser = ocorrencia?.utilizador?.entidade?.nome;

      if (!ocorrencia) {
        postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
        return;
      }
      const tecnico = await GetUserNameTecnico(ocorrencia.utilizador_id); 
        
      const seletedOcorrenciaReulst = {
        id: ocorrencia.id,
        // Idetificacao
        distrito: ocorrencia.distrito ?? undefined,
        concelho: ocorrencia.concelho ?? undefined,
        freguesia: ocorrencia.freguesia ?? undefined,
        capitania: ocorrencia.capitania ?? undefined,
        praia: ocorrencia.praia ?? undefined,
        arh: ocorrencia.arh ?? undefined,
        nuts1: ocorrencia.nuts1 ?? undefined,
        nuts2: ocorrencia.nuts2 ?? undefined,
        nuts3: ocorrencia.nuts3 ?? undefined,
        massaAgua: ocorrencia.massa_agua ?? undefined,
        dataHoraRegistro: ocorrencia.data_registo ? moment.utc(ocorrencia.data_registo).tz(CURRENT_TIMEZONE) :undefined ,

        dataHoraOcorrencia: ocorrencia.data_ocorrencia ? moment.utc(ocorrencia.data_ocorrencia).tz(CURRENT_TIMEZONE) : undefined,
        entidade_registo: ocorrencia.entidade?.nome ?? undefined,
        entidade: ocorrencia.entidade ?? undefined,
        observacao: ocorrencia.observacoes ?? undefined,
        tecnico: tecnico,
        detecaoOcorrencia: ocorrencia.tipo_detecao_id ?? undefined,
        // Detalhes
        instabiladeArribas: ocorrencia.tip_inst_arribas ?? undefined,
        movimentoMassa: ocorrencia.tip_mmv ?? undefined,
        tip_mmv_alcance_deposito: ocorrencia.tip_mmv_alcance_deposito ?? undefined,
        fendaTracao: ocorrencia.tip_fenda_visivel ?? undefined,
        erosaoRecuo: ocorrencia.tip_erosao_arribas ?? undefined,
        escarpamento: ocorrencia.tip_escarpamento_duna ?? undefined,
        tip_altura_maxima_escarpa: ocorrencia.tip_altura_maxima_escarpa ?? undefined,
        rebaixamento: ocorrencia.tip_rebaixamento_praia ?? undefined,
        tip_reb_praia_altura_max: ocorrencia.tip_reb_praia_altura_max ?? undefined,
        galgamento: ocorrencia.galgamento_costeiro ?? undefined,
        tip_galg_cost_alcance_max: ocorrencia.tip_galg_cost_alcance_max ?? undefined,
        protecaoDefesa:  ocorrencia.tip_dano_obra ?? undefined,
        estruturaAderente: ocorrencia.tip_dano_estrutura_aderente ?? undefined,
        esporao: ocorrencia.tip_dano_esporao ?? undefined,
        protecaoEstabilizacao: ocorrencia.tip_dano_estrutura_protecao ?? undefined,
        ref_localizacao: ocorrencia.ref_localizacao ?? undefined,
        pessoaEmRisco: ocorrencia.tipo_pessoas_risco_id ?? undefined,
        fruicaoUsoPublico: ocorrencia.conseq_danos_areas_construidas ?? undefined,
        danosEdificacoes: ocorrencia.conseq_danos_edificacoes ?? undefined,
        outrosDanos: ocorrencia.conseq_danos_outras ?? undefined,
        outrosDanosDescricao: ocorrencia.conseq_danos_outras_obs ?? undefined,
        sistemasNaturais: ocorrencia.tipo_danos_sistemas_naturais_id ?? undefined,
        descricaoDanosSistemasNaturais: ocorrencia.danos_sistemas_naturais_obs ?? undefined,
        naoSabe: ocorrencia.causas_nao_sabe ?? undefined,
        tempestade: ocorrencia.causas_tempestade ?? undefined,
        descricaoTempestade: ocorrencia.causas_tempestade_obs ?? undefined,
        sismos: ocorrencia.causas_sistemos ?? undefined,
        outras: ocorrencia.causas_outras ?? undefined,
        descricaoOutras: ocorrencia.causas_ouras_obs ?? undefined,
        medidasMetigacao: ocorrencia.tipo_medida_mitigacao_id ?? undefined,
        sinalizacao: ocorrencia.mitig_sinalizacao ?? undefined,
        delimitacao: ocorrencia.mitig_delimitacao ?? undefined,
        saneamento: ocorrencia.mitig_saneamento ?? undefined,
        reabilitacao: ocorrencia.mitig_reabilitacao ?? undefined,
        reforco: ocorrencia.mitig_reforco ?? undefined,
        // Anexos
        uploadFotografia: ocorrencia.docs_fotos ?? undefined,
        uploadTopografia: '',
        uploadOutro: ocorrencia.docs_outros ?? undefined,
        utilizador_id: ocorrencia.utilizador_id ?? undefined,
        oc_estado: ocorrencia.estado ?? undefined,
        indeterminado: ocorrencia?.data_indeterminada ?? undefined,
        filedoc_cod: ocorrencia?.filedoc_cod ?? undefined,
        oc_ocorrencia_apoio_id: ocorrencia?.oc_ocorrencia_apoio_id,
        numPessoasEmRisco: ocorrencia.num_pessoas_em_risco ?? undefined,
        coord_x: ocorrencia.coord_x,
        coord_y: ocorrencia.coord_y
      }

      sessionStorage.setItem("Modulo", OCORRENCIAS_MODULE_NAME);
      postMessage({type: "form", value: "registarOcorrencia"}, "*");
      const iframe: any = document.getElementById('iframeGeoPortal')

      SessionStorageService.setItem("valoresResumo", seletedOcorrenciaReulst);

      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasSearch', value: [ocorrencia.id] },
        '*'
      )

      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasCenter', value: [ocorrencia.id] },
        '*'
      )
      if (ocorrencia.oc_ocorrencia_apoio_id) {
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlOcorrenciasApoioSearch',
            value: [ocorrencia.oc_ocorrencia_apoio_id],
          },
          '*'
        )
      }

      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasHighlightRemove', value: [ocorrencia.id] },
        '*'
      )

      // iframe.contentWindow?.postMessage(
      //   { type: 'SiarlOcorrenciasCenter', value: [ocorrencia.id] },
      //   '*'
      // )


      SessionStorageService.setItem("novaOcorrencia", 'false')
      SessionStorageService.setItem('ocorrenciaAntiga', 'true')
      sessionStorage.setItem('ocGeomEdited', 'false')


      selectOcorrenciaResultId(ocorrencia.id as number)
      selectOcorrenciaResult(seletedOcorrenciaReulst)
      setOcorrenciaSelected(seletedOcorrenciaReulst);

    }
  }

  const handleSubmit = (event: any) => {

    const modulo = sessionStorage.getItem("Modulo");

    switch (modulo) {

      case DOMINIO_HIDRICO_MODULE_NAME: {

        const patrimonioSelected = getPatrimonioSelected();
        const demarcacaoSelected = getDemarcacaoSelected();
        const processoSelected = getProcessoSelected();

        if (patrimonioSelected && patrimonioSelected?.id) {
          if (!event.id) {
            if (!patrimonioSelected.id) {
              // show message to save
            } else {
              createNewAssociationPatrimonio(event, patrimonioSelected);
            }
          } else {
            saveAssociationPatrimonio(event);
          }
        }

        if (demarcacaoSelected && demarcacaoSelected?.id) {
          if (!event.id) {
            if (!demarcacaoSelected.id) {
              // show message to save
            } else {
              createNewAssociationDemarcacao(event, demarcacaoSelected);
            }
          } else {
            saveAssociationDemarcacao(event);
          }
        }

        if (processoSelected && processoSelected?.id) {
          if (!event.id) {
            if (!processoSelected.id) {
              // show message to save
            } else {
              createNewAssociationProcesso(event, processoSelected);
            }
          } else {
            saveAssociationProcesso(event);
          }
        }

        break;
      }

      case INTERVENCAO_MODULE_NAME: {
        
        const intervencaoSelected = getIntervencaoSelected();
        const acaoSelected = getAcaoSelected();
        const candidaturaSelected = getCandidaturaSelected();
        const mobilizacaoSelected = getMobilizacaoSelected();

        if (intervencaoSelected && intervencaoSelected?.id) {
          if (!event.id) {
            if (!intervencaoSelected.id) {
              // show message to save
            } else {
              createNewAssociationIntervencao(event, intervencaoSelected);
            }
          } else {
            saveAssociationIntervencao(event);
          }
        }
         if (acaoSelected && acaoSelected?.id) {
          if (!event.id) {
            if (!acaoSelected.id) {
              // show message to save
            } else {
              createNewAssociationAcao(event, acaoSelected);
            }
          } else {
            saveAssociationAcao(event);
          }
        }if (candidaturaSelected && candidaturaSelected?.id) {
          if (!event.id) {
            if (!candidaturaSelected.id) {
              // show message to save
            } else {
              createNewAssociationCandidatura(event, candidaturaSelected);
            }
          } else {
            saveAssociationCandidatura(event);
          }
        }if (mobilizacaoSelected && mobilizacaoSelected?.id) {
          if (!event.id) {
            if (!mobilizacaoSelected.id) {
              // show message to save
            } else {
              createNewAssociationMobilizacao(event, mobilizacaoSelected);
            }
          } else {
            saveAssociationMobilizacao(event);
          }
        }
        
        break;
      }

      case ENTIDADES_MODULE_NAME: {

        if (!event.id) {
          if (!selectedEntidadeResult?.id) {
            createEntidade({ tipo_entidade_id: 1, nome: '' }).then(result => {
              createNewAssociationEntidade(event, result);
              postMessage({ type: 'guardarEntidade', value: { id: result.id } }, '*')
              selectEntidadeResult(result);
            });
          } else {
            createNewAssociationEntidade(event, selectedEntidadeResult);
          }
        } else {
          saveAssociationEntidade(event);
        }
        break;
      }

      case OCORRENCIAS_MODULE_NAME: {

        if (!event.id) {
          if (!selectedOcorrenciaResult?.id && !getOcorrenciaSelected()?.id) {
            // show message to save
          } else {
            createNewAssociationOcorrencia(event, selectedOcorrenciaResult ?? getOcorrenciaSelected());
          }
        } else {
          const record = event ?? (selectedOcorrenciaResult ?? getOcorrenciaSelected());
          saveAssociationOcorrencia(record);
        }

        break;
      }

      case USO_DO_SOLO_MODULE_NAME: {

        if (!event.id) {
          if (!getUsoSoloSelected()?.id) {
            // show message to save
          } else {
            createNewAssociationUsTitulos(event, getUsoSoloSelected());
          }
        } else {
          saveAssociationUsTitulo(event);
        }

        break;
      }


      case DOCUMENTOS_MODULE_NAME: {

        if (!event.id) {
          const documentoSelected = getDocumentoSelected();
          if (!documentoSelected?.id) {
            postMessage({type: "errorMsg", value: {message: "É necessário gravar primeiro."}});
          } else {
            createNewAssociationDocumento(event, documentoSelected);
          }
        } else {
          saveAssociationDocumento(event);
        }

        break;
      }

      case APOIO_GESTAO_MODULE_NAME: {

        const pretensaoSelected = getPretensaoSelected();
        const desconformidadeSelected = getDesconformidadeSelected();
        if (pretensaoSelected && pretensaoSelected?.id) {
          if (!event.id) {
            if (!pretensaoSelected.id) {
              // show message to save
            } else {
              createNewAssociationAgPretensao(event, pretensaoSelected);
            }
          } else {
            saveAssociationPretensoes(event);
          }
        }
        if (desconformidadeSelected && desconformidadeSelected.id) {
          if (!event.id) {
            if (!desconformidadeSelected.id) {
              // show message to save
            } else {
              createNewAssociationAgDesconformidade(event, desconformidadeSelected);
            }
          } else {
            saveAssociationDesconformidades(event);
          }
        }

        break;
      }
    }

  };

  const createNewAssociationProcesso = (event: any, result?: any) => {
    if (result) {
      selectProcessoResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade ? event?.agDesconformidade.id : undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: result?.id,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }
    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByProcesso(result?.dh_processo_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationEntidade = (event: any, result?: any) => {
    if (result) {
      selectEntidadeResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade ? event?.agDesconformidade.id : undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: result?.id,
      us_titulo_id: event?.usTitulo?.id ?? undefined,

    }
    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByEntidade(result?.di_entidade_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationUsTitulos = (event: any, result?: any) => {
    if (result) {
      selectModeloResult(result);
    }
    const dataToSend = {
       oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade ? event?.agDesconformidade.id : undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      us_titulo_id: result?.id,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByUsosSolo(result?.us_titulo_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationDocumento = (event: any, result?: any) => {
    if (result) {
      setDocumentoSelected(result);
    }
    const dataToSend = {
     oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade ? event?.agDesconformidade.id : undefined,
      do_documento_id: result?.id,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByDocumento(result?.do_documento_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationAgPretensao = (event: any, result?: any) => {
    if (result) {
      setPretensaoSelected(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: result?.id,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByPretensoes(result?.ag_pretensao_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationAgDesconformidade = (event: any, result?: any) => {
    if (result) {
      setDesconformidadeSelected(result);
    }
    const dataToSend = {
       oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: result?.id,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByDesconformidades(result?.ag_desconformidade_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }
  
  const createNewAssociationOcorrencia = (event: any, result?: any) => {
    if (result) {
      selectOcorrenciaResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: result?.id,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByOcorrencia(result?.oc_ocorrencia_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationPatrimonio = (event: any, result?: any) => {
    if (result) {
      selectPatrimonioResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: result?.id,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByPatrimonio(result?.dh_patrimonio_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationDemarcacao = (event: any, result?: any) => {
    if (result) {
      selectDemarcacaoResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: result?.id,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByDemarcacao(result?.dh_demarcacao_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationIntervencao = (event: any, result?: any) => {
    if (result) {
      selectIntervencaoResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: result?.id,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByIntervencao(result?.int_intervencao_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }

  const createNewAssociationAcao = (event: any, result?: any) => {
    if (result) {
      selectAcaoResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: result?.id,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByAcao(result?.int_acao_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }
  const createNewAssociationCandidatura = (event: any, result?: any) => {
    if (result) {
      selectCandidaturaResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: result?.id,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByCandidatura(result?.int_candidatura_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }
  const createNewAssociationMobilizacao = (event: any, result?: any) => {
    if (result) {
      selectAcaoResult(result);
    }
    const dataToSend = {
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: result?.id,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.diEntidade ? event?.diEntidade.id : undefined,
    }

    createAssociation(dataToSend).then(result => {
      postMessage({ type: 'showLoader' }, '*');
      getAssociacoesByMobilizacao(result?.int_mobilizacao_id).then(result => {
        setData(result);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
    setOpenForm(false);
  }


  const saveAssociationProcesso = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByProcesso(result?.dh_processo_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationEntidade = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      di_entidade_id: event?.di_entidade_id,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByEntidade(result?.di_entidade_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationOcorrencia = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByOcorrencia(result?.oc_ocorrencia_id).then(result => {
        setData(result);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationUsTitulo = (event: any) => {
    const dataToSend = {
     id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByUsosSolo(result?.us_titulo_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationDocumento = (event: any) => {
    const dataToSend = {
     id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByDocumento(result?.do_documento_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationPretensoes = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByPretensoes(result?.ag_pretensao_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationDesconformidades = (event: any) => {
    const dataToSend = {
       id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByDesconformidades(result?.ag_desconformidade_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationPatrimonio = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByPatrimonio(result?.dh_patrimonio_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationDemarcacao = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByDemarcacao(result?.dh_demarcacao_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

   const saveAssociationIntervencao = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByIntervencao(result?.int_intervencao_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const saveAssociationAcao = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event.intAcao.id : undefined,    
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,  
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByAcao(result?.int_acao_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }
  const saveAssociationCandidatura = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByCandidatura(result?.int_candidatura_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }
   const saveAssociationMobilizacao = (event: any) => {
    const dataToSend = {
      id: event?.id,
      oc_ocorrencia_id: event?.ocOcorrencia ? event?.ocOcorrencia.id : undefined,
      ag_pretensao_id: event?.agPretensao ? event?.agPretensao.id : undefined,
      ag_desconformidade_id: event?.agDesconformidade?.id ?? undefined,
      do_documento_id: event?.doDocumento ? event?.doDocumento.id : undefined,
      mo_modelo_id: event?.moModelo ? event?.moModelo?.id : undefined,
      dh_patrimonio_id: event?.dhPatrimonio ? event?.dhPatrimonio.id : undefined,
      dh_processo_id: event?.dhProcessos ? event?.dhProcessos.id  : undefined,
      dh_demarcacao_id: event?.dhDemarcacao ? event?.dhDemarcacao.id : undefined,
      int_intervencao_id: event?.intIntervencao ? event?.intIntervencao.id : undefined,
      int_acao_id: event?.intAcao ? event?.intAcao.id : undefined,
      int_candidatura_id: event?.intCandidatura ? event?.intCandidatura.id : undefined,
      int_mobilizacao_id: event?.intMobilizacao ? event?.intMobilizacao.id : undefined,
      us_titulo_id: event?.usTitulo?.id ?? undefined,
      di_entidade_id: event?.di_entidade_id,
    }

    postMessage({ type: 'showLoader' }, '*');
    updateAssociation(dataToSend).then(result => {
      getAssociacoesByMobilizacao(result?.int_mobilizacao_id).then(result1 => {
        setData(result1);
        setOpenForm(false);
        postMessage({ type: 'hideLoader' }, '*')
      });
    });
  }

  const addNew = (e: any) => {
    setOpenForm(true);
    setEditItem({ id: undefined });
    e.preventDefault();
    return;
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const cancelModalDescartar = () => {
    setOpenModalDescartar(false)
  }

  const handleDescartar = async (e: any) => { 
    const result = await deleteAssociacao(idToRemove);
    setOpenModalDescartar(false);
    initForm();
  }


  const MyEditCommandCell = (props: GridCellProps) => (
    <EditCommandCell {...props} viewMode={viewMode} enterEdit={enterEdit} pointOnMap={pointOnMap} deleteItem={deleteItem} goToForm={goToForm} />
  );
  const CustomHtmlCell = (props: GridCellProps) => {
    return (
      <div>{parse(props.dataItem?.resumo)}</div>
    )
  }
  const editField = "inEdit";
  return (
    <>
      <Grid
        className={` ${selectedStyles.form} ${viewMode? 'customGridVisualizar' : 'k-grid.k-grid-md.GridDocumentos_form__Kg7bw.customGrid'} `}
        editField={editField}
        dataItemKey={"id"}
        data={
        data
            ?.filter((item : any)=> item?.tipo !== "Documento") 
            .map((data: any) => ({
              ...data,
              resumo: data?.resumo.replaceAll('|', '<br/>'),
              observacoesOcorrencia: data?.ocOcorrencia?.observacoes ? data?.ocOcorrencia?.observacoes.slice(0, 50) : '',
            }))
            .slice(page.skip, page.take + page.skip)
        }
        pageable={{
          buttonCount: 5,
          info: true,
          type: 'numeric',
          pageSizes: true,
          previousNext: true,
        }}
        skip={page.skip}
        take={page.take}
        total={data?.length - 1}
        onPageChange={handlePageChange}
      >
        {!viewMode ? (
        <GridToolbar>
          <button
            title="Nova associação"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnPrimaryColor"
            onClick={(e) => { addNew(e) }}
            style={{textTransform: 'none'}}
          >
            <span className="icon-siarl icon-registar k-button-icon"></span>{' '}
            &nbsp;{' '}
            Nova associação
          </button>
        </GridToolbar>
        ) : ""}

        <GridColumn cell={MyEditCommandCell} width={'50px'} />
        <GridColumn field="tipo" title="Tipo" />
        <GridColumn title="Dados do registo" cell={CustomHtmlCell} />
      </Grid>
      {openForm && (
        <EditAssociacaoForm
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
            {openModalDescartar ? (
          <Dialog
            
            className={styles.dialogDesconformidades}
            onClose={cancelModalDescartar}
          >
            
            <Form
              initialValues={
                {
                } 
              }
              render={(formRenderProps) => (
                <FormElement style={{ maxWidth: 500 }}>
                  <fieldset>
                    <span className="textDescartar">Tem a certeza que deseja apagar esta associação?  </span>
                    <br></br>
                  </fieldset>
                  <br></br>
                  <div className="k-form-buttons btnModal">                    
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar"
                      onClick={handleDescartar}

                    >
                      Sim
                    </button>
                    <button
                      type={'submit'}
                      className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                      onClick={cancelModalDescartar}
                    >
                      Não
                    </button>
                  </div>
                </FormElement>
              )}
            />
          </Dialog>
        ) : (
          <></>
        )}
    </>
  )
}

